var _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { action } from '@ember/object';
import TpkSelect, { moveOperations, SelectActions } from './tpk-select';
let TpkSelectSearch = (_class = class TpkSelectSearch extends TpkSelect {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "keyToOpenSelectAction", {
      ArrowUp: SelectActions.Previous,
      ArrowDown: SelectActions.Next,
      PageUp: SelectActions.PageUp,
      PageDown: SelectActions.PageDown,
      Escape: SelectActions.Close,
      Enter: SelectActions.CloseSelect,
      Tab: SelectActions.CloseSelect
    });
  }
  onInput(e) {
    this.isOpen = true;
    this.args.onInput(e.target.value);
  }
  navigate(action) {
    if (action === SelectActions.First) {
      this.activeChildIndex = 0;
      return;
    }
    if (action === SelectActions.Last) {
      this.activeChildIndex = this.children.length - 1;
      return;
    }
    if (this.activeChildIndex === undefined) {
      this.activeChildIndex = 0;
      return;
    }
    let value = moveOperations[action];
    const res = this.activeChildIndex + value;
    if (res > this.args.options.length - 1) {
      this.activeChildIndex = 0;
    } else if (res < 0) {
      this.activeChildIndex = this.args.options.length - 1;
    } else if (res === 0) {
      this.activeChildIndex = 0;
    } else {
      this.activeChildIndex = res;
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "onInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInput"), _class.prototype)), _class);
export { TpkSelectSearch as default };